import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_AKTUALISIEREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerAktualisierenAdmin laden';
export const POST_BENUTZER_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerAktualisierenAdmin ausführen';
export const POST_BENUTZER_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerAktualisierenAdmin laden erfolgreich';
export const POST_BENUTZER_AKTUALISIEREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerAktualisierenAdmin Ladefehler';
export const POST_BENUTZER_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerAktualisierenAdminAction implements Action {
    readonly type = POST_BENUTZER_AKTUALISIEREN_ADMIN;
        constructor(public benutzerNameRequest: api.BenutzerNameRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerNameRequest: api.BenutzerNameRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerNameRequest: api.BenutzerNameRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerNameRequest: api.BenutzerNameRequest, public optPayload: any = null) {}
    }
export class PostBenutzerAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerAktualisierenAdminActions =
    PostBenutzerAktualisierenAdminAction
    | PostBenutzerAktualisierenAdminAusfuehrenAction
    | PostBenutzerAktualisierenAdminErfolgreichAction
    | PostBenutzerAktualisierenAdminFehlerAction
    | PostBenutzerAktualisierenAdminNichtAusgefuehrtAction
    ;
